if (!customElements.get("variant-selects")) {
    class VariantSelects extends HTMLElement {
        constructor() {
            super();

            this.addEventListener("change", this.onVariantChange);

            // variants
            this.variants = this.querySelectorAll("[data-product-form]");

            // stock counter block
            this.availableVariants = document.querySelectorAll(
                "input.variant__configurable"
            );
            this.stockCounterContainer = document.querySelectorAll(
                ".stock__counter.configurable"
            );

            /** on page refresh
             * update selected variant stock status label
             * update mark unavailable variants
             */
            this.updateVariantsStockOptions();
        }

        updateVariantsStockOptions() {
            if (!!!this.getVariantData()) return;

            // get the first available variant
            const firstAvailableVariant = this.getVariantData().find(
                (variant) => variant.available
            );
            const variantId =
                new URLSearchParams(window.location.search).get("variant") ??
                firstAvailableVariant?.id ??
                this.getVariantData()[0]?.id;

            this.markUnavailableVariant();

            this.getVariantData().find((variant) => {
                if (variantId && variant.id == variantId) {
                    this.showStockCounterConfigurableProducts(variant);
                }
            });
        }

        onVariantChange(event) {
            const variants = event.target.closest(".variants");
            if (!variants) return;

            const sectionId = variants.dataset.section;
            const oldProductUrl = variants.dataset.url;

            const optionValueElement =
                event.target.closest("[data-product-url]");
            const newProductUrl =
                optionValueElement?.dataset.productUrl || oldProductUrl;

            const selectedOptionValueIds = this.getSelectedOptionValueIds();

            const params = selectedOptionValueIds.length
                ? `&option_value_ids=${selectedOptionValueIds.join(",")}`
                : "";

            // abort previous request
            if (this._abortController) this._abortController.abort();

            const controller = new AbortController();
            this._abortController = controller;

            // ***
            // COMBINED LISTINGS
            // ***
            if (newProductUrl && oldProductUrl !== newProductUrl) {
                const sections = this.getSectionsToRender();

                if (!sections.length) return;

                const url = new URL(newProductUrl, window.location.origin);

                url.searchParams.set("sections", sections.join(","));

                if (selectedOptionValueIds.length) {
                    url.searchParams.set(
                        "option_value_ids",
                        selectedOptionValueIds.join(",")
                    );
                }

                fetch(url.toString(), {
                    signal: controller.signal,
                })
                    .then(async (r) => {
                        const text = await r.text();

                        try {
                            return JSON.parse(text);
                        } catch (e) {
                            console.error("Invalid JSON response:", text);
                            // throw new Error("Sections response is not valid JSON");
                        }
                    })
                    .then((sectionsHtml) => {
                        if (this._abortController !== controller) return;

                        this.replaceSections(sectionsHtml);

                        this.updateBrowserURL(
                            newProductUrl,
                            selectedOptionValueIds
                        );
                        this.updateRevealAnimation();

                        //dispatch section load event
                        document.dispatchEvent(
                            new CustomEvent("shopify:section:load")
                        );
                    })
                    .catch((err) => {
                        if (err.name === "AbortError") return;
                        console.error(err);
                    });

                return;
            }

            // ***
            // common configurable product
            // ***
            fetch(`${newProductUrl}?section_id=${sectionId}${params}`, {
                signal: controller.signal,
            })
                .then((r) => r.text())
                .then((htmlText) => {
                    if (this._abortController !== controller) return;

                    const html = new DOMParser().parseFromString(
                        htmlText,
                        "text/html"
                    );

                    this.updateVariantOptions(html, event, variants);

                    // old theme code here
                    this.syncVariantState(optionValueElement);
                })
                .catch((err) => {
                    if (err.name === "AbortError") return;
                    console.error(err);
                });
        }

        getSectionsToRender() {
            const mainContent = document.querySelector("#MainContent");
            return [
                ...mainContent.querySelectorAll("[data-renderable='true']"),
            ].map((el) => el.dataset.sectionId);
        }

        updateVariantOptions(html, event, variants) {
            const group = event.target.closest("[data-option-index]");
            if (!group) return;

            const idx = group.dataset.optionIndex;

            const newGroup = html.querySelector(`[data-option-index="${idx}"]`);

            if (!newGroup) return;

            const oldSelect = group.querySelector("select");
            const newSelect = newGroup.querySelector("select");

            if (oldSelect && newSelect) {
                const selectedValue = oldSelect.value;

                oldSelect.innerHTML = newSelect.innerHTML;

                if (selectedValue) {
                    const option = oldSelect.querySelector(
                        `[value="${CSS.escape(selectedValue)}"]`
                    );
                    if (option) option.selected = true;
                }
            } else {
                const selectedValue = group.querySelector(
                    "[type=radio]:checked"
                )?.value;

                group.innerHTML = newGroup.innerHTML;

                if (selectedValue) {
                    const input = group.querySelector(
                        `[value="${CSS.escape(selectedValue)}"]`
                    );
                    if (input) input.checked = true;
                }
            }
        }
        // old theme code
        syncVariantState(optionValueElement) {
            if (optionValueElement?.dataset?.optionValueId) {
                const variant = `[data-option-value-id="${optionValueElement.dataset.optionValueId}"]`;
                document.querySelector(variant)?.focus();
            }

            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, "", false);
            this.updatePickupAvailability();
            this.removeErrorMessage();
            this.markUnavailableVariant();

            if (!this.currentVariant) {
                this.toggleAddButton(true, "", true);
                this.setUnavailable();
                this.showStockCounterConfigurableProducts(!this.currentVariant);
            } else {
                this.updateMedia();
                this.updateURL();
                this.updateVariantInput();
                this.renderProductInfo();
                this.showStockCounterConfigurableProducts(this.currentVariant);
            }
        }

        replaceSections(sectionsHtml) {
            Object.entries(sectionsHtml).forEach(([sectionId, html]) => {
                const oldSection = document.querySelector(
                    `#shopify-section-${sectionId}`
                );

                if (!oldSection) return;

                const parsed = new DOMParser().parseFromString(
                    html,
                    "text/html"
                );
                const newContent = parsed.querySelector(
                    `#shopify-section-${sectionId}`
                );

                if (!newContent) return;

                oldSection.replaceWith(newContent);
            });
        }

        getSelectedOptionValueIds() {
            return [
                ...this.querySelectorAll(
                    "[data-option-value-id]:checked, [data-option-value-id] option:checked"
                ),
            ]
                .map((el) => el.dataset.optionValueId)
                .filter(Boolean);
        }

        updateBrowserURL(productUrl, optionValueIds = []) {
            if (!productUrl) return;
            // update url for Combined listing product
            const url = new URL(productUrl, window.location.origin);

            if (optionValueIds.length) {
                url.searchParams.set(
                    "option_value_ids",
                    optionValueIds.join(",")
                );
            } else {
                url.searchParams.delete("option_value_ids");
            }

            // update history
            if (window.location.href !== url.toString()) {
                window.history.replaceState({}, "", url.toString());
            }
        }

        markUnavailableVariant() {
            if (this.dataset.markUnavailableVariant == "false") return;

            const findVariant = (options) =>
                this.getVariantData().find(
                    (v) => v.options.join(",") === options.join(",")
                );

            this.variants.forEach((form) => {
                const select = form.querySelector("select");
                const radios = form.querySelectorAll("[type=radio]");

                if (select) {
                    for (let item of select.options) {
                        let variant,
                            options = this.selectedOptions();

                        options[form.dataset.optionIndex] = item.value;
                        variant = findVariant(options);
                        if (variant) {
                            if (variant.available)
                                item.removeAttribute("disabled");
                            else item.setAttribute("disabled", true);
                        } else {
                            item.setAttribute("disabled", true);
                        }
                    }
                }

                if (radios) {
                    radios.forEach((radio) => {
                        // disable markunavailable variants for the combined listing
                        if (radio.dataset.combinedListing == "true") return;
                        let variant,
                            options = this.selectedOptions();

                        options[form.dataset.optionIndex] = radio.value;
                        variant = findVariant(options);

                        if (variant) {
                            const isTracked =
                                variant.inventory_management !== null;

                            const isAvailable = isTracked
                                ? variant.available
                                : true; // when inventory not tracked

                            radio.classList[isAvailable ? "remove" : "add"](
                                "unavailable-option"
                            );
                        } else {
                            radio.classList.add("unavailable-option");
                        }
                    });
                }
            });
        }

        selectedOptions() {
            const options = [];

            this.querySelectorAll("[data-product-form]").forEach((form) => {
                options[form.dataset.optionIndex] = form.querySelector(
                    "[type=radio]:checked, select"
                ).value;

                this.updateLegendLabel(
                    form.querySelector("[type=radio]:checked, select")
                );
            });

            const mediaItems = document.querySelectorAll(
                "a[data-option-color]"
            );
            if (!mediaItems) {
                return options;
            }

            const selectedColor = options[0];
            mediaItems.forEach((item) => {
                const itemColor = item.dataset.optionColor;
                const shouldShow =
                    !selectedColor || itemColor === selectedColor;

                item.classList.toggle("hidden", !shouldShow);
            });

            return options;
        }

        setOptionName(name, labelName, input) {
            name.innerHTML =
                labelName +
                ":&nbsp;" +
                '<span class="lighter _capitalize">' +
                input.value +
                "</span>";
        }

        updateLegendLabel(input) {
            const label = input.closest(
                ".product-form__input"
            ).firstElementChild;
            const labelName =
                input.firstElementChild?.dataset.optionName || input.name;

            setTimeout(() => {
                this.setOptionName(label, labelName, input);
            });
        }

        updateOptions() {
            this.options = Array.from(
                this.querySelectorAll("select"),
                (select) => select.value
            );
        }

        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options
                    .map((option, index) => {
                        return this.options[index] === option;
                    })
                    .includes(false);
            });
        }

        updateMedia() {
            const gallery = document.getElementById(
                `gallery-${this.dataset.section}`
            );

            if (!gallery) return;
            const sliderItems = gallery.querySelectorAll("li");

            sliderItems?.forEach((item, index) => {
                const mediaId = Number(item.dataset.mediaId);
                if (
                    typeof gallery?.activateSlide == "function" &&
                    mediaId === this.currentVariant?.featured_media?.id
                ) {
                    gallery?.activateSlide?.(item);
                }
            });
        }

        async updateRevealAnimation() {
            const revealItems = document.querySelectorAll(".reveal-slide-in");
            typeof onReveal === "function" &&
                revealItems.length &&
                (await onReveal(revealItems));
        }

        updateURL() {
            if (!this.currentVariant || this.dataset.updateUrl === "false")
                return;
            window.history.replaceState(
                {},
                "",
                `${this.dataset.url}?variant=${this.currentVariant.id}`
            );
        }

        removeErrorMessage() {
            const section = this.closest("section");
            if (!section) return;

            const productForm = section.querySelector("product-form");
            if (productForm) productForm.handleErrorMessage?.();
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(
                `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-${this.dataset.productId}, #product-form-installment, #product-form-add-to-cart-sticky`
            );
            productForms.forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        updatePickupAvailability() {
            const pickUpAvailability = document.querySelector(
                "pickup-availability"
            );
            if (!pickUpAvailability) return;

            if (this.currentVariant?.available) {
                pickUpAvailability.fetchAvailability(this.currentVariant.id);
            } else {
                pickUpAvailability.removeAttribute("available");
                pickUpAvailability.innerHTML = "";
            }
        }

        renderProductInfo() {
            const ids = this.getUpdatable();

            fetch(
                `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
            )
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(
                        responseText,
                        "text/html"
                    );

                    ids.map((id) => {
                        const destination = document.getElementById(id);
                        const source = html.getElementById(id);

                        if (source && destination)
                            destination.innerHTML = source.innerHTML;
                        destination?.classList.remove("invisible");
                    });

                    this.toggleAddButton(
                        !this.currentVariant?.available,
                        window.variantStrings.soldOut
                    );
                });
        }

        toggleAddButton(disable = true, text, modifyClass = true) {
            const productForm = document.querySelector(
                `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-${this.dataset.productId}`
            );

            // compatibility with app Tepo Product Option
            const addButton =
                productForm?.querySelector('[name="tcustomizer-add"]') ||
                productForm?.querySelector('[name="add"]');
            if (!addButton) return;

            const stickyAddToCart = document
                .getElementById("product-form-add-to-cart-sticky")
                ?.querySelector('[name="add"]');
            const dynamicPaymentBtn = productForm?.querySelector(
                '[data-shopify="payment-button"]'
            );

            if (disable) {
                addButton.setAttribute("disabled", true);
                stickyAddToCart?.setAttribute("disabled", true);
                dynamicPaymentBtn?.setAttribute("hidden", true);
                if (text) addButton.querySelector(".text").textContent = text;
            } else {
                addButton.removeAttribute("disabled");
                stickyAddToCart?.removeAttribute("disabled", true);
                if (this.setPreorder()) {
                    dynamicPaymentBtn?.setAttribute("hidden", true);
                    addButton.querySelector(".text").textContent =
                        window.variantStrings.preorder;
                } else {
                    dynamicPaymentBtn?.removeAttribute("hidden");
                    addButton.querySelector(".text").textContent =
                        window.variantStrings.addToCart;
                }
            }

            if (!modifyClass) return;
        }

        setUnavailable() {
            const productForm = document.querySelector(
                `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-${this.dataset.productId}`
            );
            const addButton = productForm?.querySelector('[name="add"]');
            if (!addButton) return;
            addButton.querySelector(".text").textContent =
                window.variantStrings.unavailable;
            document
                .getElementById(`price-${this.dataset.section}`)
                ?.classList.add("invisible");
        }

        setPreorder() {
            const variantId =
                new URLSearchParams(window.location.search).get("variant") ??
                this.getVariantData()[0].id;
            const options = document.querySelectorAll(".options--data");
            let isPreorder = false;

            this.getVariantData().find((variant) => {
                options.forEach((option) => {
                    if (
                        variantId &&
                        variant.id == variantId &&
                        variant.id == option.dataset.variantId
                    ) {
                        if (
                            parseInt(option.dataset.variantQty) <= 0 &&
                            variant.available
                        )
                            isPreorder = true;
                    }
                });
            });

            return isPreorder;
        }

        getVariantData() {
            this.variantData =
                this.variantData ||
                JSON.parse(
                    this.querySelector('[type="application/json"]').textContent
                );
            return this.variantData;
        }

        getUpdatable() {
            var updatable = [];

            document
                .querySelectorAll('[data-updatable="true"]')
                .forEach((el) => {
                    el.id && updatable.push(el.id);
                });

            return updatable;
        }

        resetStockContainerInfo() {
            this.stockCounterContainer[0].dataset.stockQty = "";
            this.stockCounterContainer[0].innerHTML = "";
        }

        showStockCounterConfigurableProducts(currentVariant) {
            if (!this.stockCounterContainer.length) return;

            this.resetStockContainerInfo();

            let title = this.stockCounterContainer[0].dataset.title,
                inStock = this.stockCounterContainer[0].dataset.titleInStock, // for not tracked variants
                inStockTracked =
                    this.stockCounterContainer[0].dataset.titleInStockTracked,
                outOfStock =
                    this.stockCounterContainer[0].dataset.titleOutOfStock,
                thresholdQty =
                    this.stockCounterContainer[0].dataset.thresholdQty; // config option thresholdQty

            this.availableVariants.forEach((variant) => {
                if (currentVariant.id == variant.dataset.variantId) {
                    const isTracked = variant.dataset.variantTracked === "true";
                    const variantQty = parseInt(variant.dataset.variantQty);
                    /* if variant not available show Out of Stock label */
                    if (!currentVariant.available) {
                        this.stockCounterContainer[0].dataset.stockQty =
                            variantQty;

                        title = title.replace(title, outOfStock);
                        this.stockCounterContainer[0].innerHTML = title;
                    }

                    if (variantQty > parseInt(thresholdQty)) {
                        this.stockCounterContainer[0].dataset.stockQty =
                            variantQty;
                        inStockTracked = inStockTracked.replace(
                            "{{ stock_qty }}",
                            variantQty
                        );

                        title = title.replace(title, inStockTracked); // In Stock X left
                        this.stockCounterContainer[0].innerHTML = title;
                    } else {
                        this.stockCounterContainer[0].dataset.stockQty =
                            variantQty;

                        title = title.replace("X", variantQty); // Only X left
                        this.stockCounterContainer[0].innerHTML = title;
                    }

                    if (isTracked && currentVariant.available && variantQty > 10) {
                        this.stockCounterContainer[0].textContent =
                            this.stockCounterContainer[0].dataset.titleStockAbundant || "10+ units left";
                    }

                    if (!isTracked) {
                        this.stockCounterContainer[0].dataset.stockQty =
                            variantQty;
                        this.stockCounterContainer[0].innerHTML =
                            variantQty > 0 ? inStock : outOfStock;
                        return;
                    }
                }
            });
        }
    }

    customElements.define("variant-selects", VariantSelects);

    class VariantRadios extends VariantSelects {
        constructor() {
            super();
        }

        updateOptions() {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            this.options = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll("input")).find(
                    (radio) => radio.checked
                ).value;
            });
        }
    }

    customElements.define("variant-radios", VariantRadios);
}
